module.exports = {"_devnotes":"Claves de google analytics por dominio https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/692092941/Google+Analytics#GoogleAnalytics-ClavesUtilizadas","default":"UA-120004517-1","localhost":"G-LOCAL-PLACEHOLDER","dev.b2b.olympiaviajes.es":"UA-120004517-1","qa.b2b.olympiaviajes.es":"UA-120004517-1","bedbankeroski.viajesolympia.com":"UA-119880521-1","bedbank.viajesolympia.com":"G-D4PJ1NWWL6","b2b.olympiaviajes.es":"UA-119880521-2","bedbank.dawsontravel.ie":"UA-119880521-3"}


//////////////////
// WEBPACK FOOTER
// ./src/GAHostToKeys.json
// module id = 2086
// module chunks = 0